// Import model
import { StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest } from '../models/StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest instance
   */
  static deserialize(json: string): StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest instance
   */
  static fromObject(obj: any): StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest');
    }


    const instance: StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest = {
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest instances
   */
  static deserializeArray(json: string): StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest instance to a JSON string
   */
  static serialize(instance: StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest instance to a plain object
   */
  static toObject(instance: StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest): any {
    return {
      'UnlayerTemplateId': instance.unlayerTemplateId,
    };
  }

  /**
   * Serializes an array of StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAppointmentSendCustomAppointmentConfirmationEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
